import React from 'react';

import { Link, WorkflowViewContainer } from 'components/AORedesign';
import AddOrEditNewsArticle from './AddOrEditNewsArticle';

const ADD_NEWS_ARTICLE_LABEL = 'Add News Article';

const TriggerButton = (props) => (
  <Link {...props} startIcon={'addOutlined'}>
    {ADD_NEWS_ARTICLE_LABEL}
  </Link>
);

const AddNewsArticle = () => {
  return (
    <WorkflowViewContainer appBarTitle={ADD_NEWS_ARTICLE_LABEL} TriggerButton={TriggerButton}>
      <AddOrEditNewsArticle />
    </WorkflowViewContainer>
  );
};

export default AddNewsArticle;
